export const collateralSlippage = BigInt(0.0005e18) // 0.05%
export const maxLeverageAvailableBuffer = 0.02 // max available leverage from max
